"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getIndexOfClosingParen = void 0;
var getIndexOfNextSymbol_1 = __importDefault(require("./getIndexOfNextSymbol"));
/*
Not only to we skip over parenthesis inside of string literals,
we also skip over parenthesis that have matching open parenthesis

e.g.

 method(method())method())...
       ^      ^^^      ^^^
0      1      210      10X   <- we only are looking for a ")" after a '0'
                         ^found
*/
var _getIndexOfClosingParen = function (openingSymbol, closingSymbol) {
    if (openingSymbol === void 0) { openingSymbol = '('; }
    if (closingSymbol === void 0) { closingSymbol = ')'; }
    var getIndexOfNextClosingParen = (0, getIndexOfNextSymbol_1.default)(closingSymbol, Number.MAX_SAFE_INTEGER);
    var getIndexOfNextOpeningParen = (0, getIndexOfNextSymbol_1.default)(openingSymbol, Number.MAX_SAFE_INTEGER);
    var innerGetIndexOfClosingParen = function (expression, returnWhenNotFound) {
        if (returnWhenNotFound === void 0) { returnWhenNotFound = -1; }
        if (expression === '') {
            return returnWhenNotFound;
        }
        var ixOfNextOpening = getIndexOfNextOpeningParen(expression);
        var ixOfNextClosing = getIndexOfNextClosingParen(expression);
        if (ixOfNextClosing < ixOfNextOpening) {
            return ixOfNextClosing;
        }
        // lazy so we don't execute until we know indexes are useful
        var getRemainder = function () {
            if (ixOfNextClosing !== ixOfNextOpening) {
                var subexp = expression.slice(ixOfNextOpening + openingSymbol.length);
                var ixToContinueAfter = innerGetIndexOfClosingParen(subexp);
                if (ixToContinueAfter !== -1) {
                    return [
                        subexp.slice(ixToContinueAfter + closingSymbol.length),
                        ixOfNextOpening + openingSymbol.length + ixToContinueAfter + closingSymbol.length,
                    ];
                }
            }
            return ['', -1];
        };
        var _a = getRemainder(), remainder = _a[0], ixOfRemainder = _a[1];
        if (remainder) {
            var restIx = innerGetIndexOfClosingParen(remainder);
            return restIx === -1 ? returnWhenNotFound : ixOfRemainder + restIx;
        }
        return returnWhenNotFound;
    };
    return innerGetIndexOfClosingParen;
};
exports._getIndexOfClosingParen = _getIndexOfClosingParen;
var getIndexOfClosingParen = (0, exports._getIndexOfClosingParen)();
exports.default = getIndexOfClosingParen;
//# sourceMappingURL=getIndexOfClosingParen.js.map